import { ToolingItemForm } from "./ToolingItemForm";

export default function ToolingItemCreatePage() {
  return (
    <div className="w-full px-4 sm:px-6 py-4">
      <ToolingItemForm />
    </div>
  );
}
